import React from "react";
import "./businessDropDownOption.css";
import { Link } from "react-router-dom";

const BusinessDropDownOption = ({ icon, title, pageLink }) => {
  return (
    <Link to={pageLink} className="businessOption">
      <div className="businessOption">
        <div className="businessOption-icon">
          <img src={icon} alt="" />
        </div>
        <div className="businessOption-content">
          <h5>{title}</h5>
        </div>
      </div>
    </Link>
  );
};

export default BusinessDropDownOption;
